import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CarIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 3c1.56 0 2.986.143 4.278.431a4 4 0 013.007 2.92l.045.2.09.449H21a1 1 0 01.117 1.993L21 9h-1.181l.1.49a4 4 0 01.481.31l.4.3a3 3 0 011.2 2.4V15a2 2 0 01-.999 1.732L21 18a2 2 0 01-1.85 1.995L19 20h-1a2 2 0 01-1.995-1.85L16 18v-1H8v1a2 2 0 01-1.85 1.995L6 20H5a2 2 0 01-1.995-1.85L3 18v-1.268A2 2 0 012 15v-2.5a3 3 0 011.2-2.4l.4-.3a4 4 0 01.482-.31L4.18 9H3a1 1 0 01-.117-1.993L3 7h1.579l.091-.449a4 4 0 012.852-3.07l.2-.05C9.013 3.143 10.44 3 12 3zM6 17H5v1h1v-1zm13 0h-1v1h1v-1zm-1-6H6a2 2 0 00-1.2.4l-.4.3a1 1 0 00-.4.8V15h16v-2.5a1 1 0 00-.4-.8l-.4-.3A2 2 0 0018 11zm-6-6c-1.42 0-2.7.129-3.843.383A2 2 0 006.668 6.79l-.037.153L6.22 9H17.78l-.411-2.057a2 2 0 00-1.526-1.56C14.7 5.13 13.42 5 12 5z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
CarIcon.isCarinaIcon = true;
export default CarIcon;
